module Tapas.Bindings {
    export class InstantSearchButtonControl {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var resultRowClassName = valueAccessor();
            var number = -1;
            var resultCount = -1;
            var targetElement = $(element);
            var resultRows = $(resultRowClassName); 

            targetElement.on('submit', function () {
                if (number > -1) {
                    var url = $(resultRowClassName + '.active a').attr('href');
                    window.location.href = url;
                    return false;
                }
                return true;
            });          
			
            targetElement.on("keydown", function (e) {
                if (e.which == 38 || e.which == 40)
                    e.preventDefault();
            });            
            targetElement.bind('input', function (e) { 
                number = -1;
            });
            function upAndDown() {
                var resultRows = $(resultRowClassName);
                resultCount = resultRows.length - 1;
                //Make sure user cant go over or under
                if (number > resultCount) {
                    number = -1;
                } else if (number < -1) {
                    number = resultCount;
                }
                resultRows.removeClass('active');
                $(resultRowClassName + '.' + number).addClass('active');
            }
            targetElement.on("keyup", function (e) {
                var code = e.which;
                if (code == 40) { // Up key
                    number++;
                    upAndDown();
                } else if (code == 38) { //Down key
                    number--;
                    upAndDown();
                }
            });
        }
    }
    ko.bindingHandlers['instantSearchButtonControls'] = new InstantSearchButtonControl();
}